/*
 * @Author: zyy
 * @Date: 2022-03-28 10:51:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-17 10:44:45
 * @Description: default
 */
import axios from 'axios';
import router from '@/router';

import Message from 'ant-design-vue/lib/message';

import {
  $getCookie
} from '@/plugins/utils.js';

import '@/assets/js/pace.min.js';

const $downloadFile = (content, name) => {
  const blob = new Blob([content]);
  const fileName = name;
  if ('download' in document.createElement('a')) { // 非IE下载
    const link = document.createElement('a');
    link.download = fileName;
    link.style.display = 'none';
    link.href = URL.createObjectURL(blob);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(link.href); // 释放URL 对象
    document.body.removeChild(link);
  } else { // IE10+下载
    navigator.msSaveBlob(blob, fileName);
  }
}

// 初始化Pace
window.paceOptions = {
  ajax: {
    trackMethods: ["GET", "POST", "DELETE", "PUT", "PATCH"]
  }
};

Pace.on("hide", () => {
  Pace.stop();
});

axios.defaults.baseURL = process.env.VUE_APP_DOMAIN;

axios.interceptors.request.use(
  config => {
    const token = $getCookie('token');
    const communityId = $getCookie('communityId');
    const setHeaders = (name, value) => {
      config.headers[name] = value;
    };

    if (token) {
      setHeaders('Authorization', token);
    }
    if (communityId) {
      setHeaders('X-COMMUNITY-ID', communityId);
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

axios.interceptors.response.use(
  res => {
    if (res.config.responseType === 'blob') {
      $downloadFile(res.data, res.headers['content-disposition'].split('filename=')[1]);
    }
    if (res.data.code === 0) {
      Message.error({ content: res.data.msg, key: 'tips', duration: 2 })
      new Promise.reject(res.data.msg)

    };
    if (res.data.code) {
      if (res.data.code == 1) {
        return res.data
      } else {
        // alert(res.data.msg)
        new Promise.reject(res.data.msg);
      }
    }
    return res.data;
  },
  err => {
    let status = err.response.status;
    let message = err.response.data.message || '未知错误';
    if (status === 401) {
      router.push('/entrance');
    } else if (status === 403) {
      router.push('/no_auth');
    } else if (status === 500) {
      router.push('/mistake');
    }
    Message.error({ content: message, key: 'tips', duration: 1 });
    return Promise.reject(err);
  }
);
